<template>
    <div class="content__container courier_content">
<!--        <div v-if="isShowMenu" class="menu_couriers">-->
<!--            <menu_couriers-->
<!--                :key="'menu_couriers'"-->
<!--            />-->
<!--        </div>-->
        <div class="courier_new">
<!--            <div class="courier_new__heading">-->
<!--                <div class="courier_new__heading_back" @click.prevent="clickBackArrow">-->
<!--                    <div class="courier_new__heading_back_arrow margin_left">-->
<!--                        <svg>-->
<!--                            <use xlink:href="/icons/base.svg#back_arrow"></use>-->
<!--                        </svg>-->
<!--                    </div>-->
<!--                    <div class="courier__heading_back_text">-->
<!--                        {{ __t('O.BACK') }}-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="courier_new__content">
                <spinner
                    v-if="is_searching"
                    :height="'100px'"
                    :width="'10px'"
                />

                <div class="courier_new__content_data" v-if="!is_searching">
                    <div class="courier_new__content_data_number">
                        <input type="text"
                               v-model="order_uniq_id"
                               class="courier_new__content_data_number_input"
                               :placeholder="__t('O.ENTER_ORDER_NUMBER')">
                    </div>
                    <button class="courier_new__content_data_button" @click.prevent="addCourier">
                        <span class="courier_new__content_data_button_text">{{ __t('O.ADD_ORDER') }}</span>
                    </button>
                </div>
            </div>
        </div>
<!--        <modal-->
<!--            v-if="isModalCourierNew && isMobileScreen"-->
<!--            :key="'modal_courier_new'"-->
<!--        >-->
<!--            <template v-slot:content>-->
<!--                <div class="courier_new">-->
<!--                    <span class="courier_new_strip"></span>-->
<!--                    <div class="courier_new__content">-->
<!--                        <spinner-->
<!--                            v-if="is_searching"-->
<!--                            :height="'100px'"-->
<!--                            :width="'10px'"-->
<!--                        />-->

<!--                        <div class="courier_new__content_data" v-if="!is_searching">-->
<!--                            <div v-if="isMobileScreen" class="courier_new__content_data_text">-->
<!--                                {{ __t('O.ENTER_ORDER_NUMBER_TO_CALL_COURIER') }}-->
<!--                            </div>-->

<!--                            <div class="courier_new__content_data_number">-->
<!--                                <input type="text"-->
<!--                                       v-model="order_uniq_id"-->
<!--                                       class="courier_new__content_data_number_input"-->
<!--                                       :placeholder="__t('O.ENTER_ORDER_NUMBER')">-->
<!--                            </div>-->
<!--                            <button class="courier_new__content_data_button" @click.prevent="addCourier">-->
<!--                                <span class="courier_new__content_data_button_text">{{ __t('O.ADD_ORDER') }}</span>-->
<!--                            </button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </template>-->
<!--        </modal>-->
    </div>
</template>

<script>
import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../../mixins/screenSize";
import {touchEvent} from "../../../mixins/touchEvent";
import spinner from "../../loader/Spinner.vue";
import menu_couriers from "../../menu/courier_pos/MenuCouriers.vue";
import modal from "../../modal/Modal.vue";
import {nameKeyDown} from "../../../mixins/nameKeyDown";

const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})


export default {
    name: "order",
    components: {
        modal,
        spinner,
        menu_couriers
    },
    mixins: [screenSize, nameKeyDown, touchEvent],
    emits: ['move_touch_down'],
    data() {
        return {
            order_uniq_id : "",
            isModalCourierNew: true,
        }
    },
    methods: {
        touchStartEvent(){
            if(this.touchElementClass === 'modal__wrapper') {
                setTimeout(() => {
                    this.clickBackArrow();
                }, 200);
            }
        },
        addCourier() {
            this.make_search();
        },
        make_search() {
            if(this.order_uniq_id.length > 0) {
                this.$store.dispatch('couriers/FETCH_ORDER', this.order_uniq_id)
                    .then((res) => {
                        if(this.go_rest_choice) {
                            this.$router.push({path: "/new/locations"});
                        }
                        else {
                            console.log('/new/courier/create')
                            //this.$router.push({path: "/new/data"});
                            this.$router.push({path: "/new/courier/create"});
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        },

        clickBackArrow() {
            this.$store.dispatch('couriers/CHANGE_STATE_NEW_COURIER', false);
            this.$router.push({path: "/courier"});
        },
        moveTouchDown(){
            this.clickBackArrow();
        },
        onKeyDown(event){
            if(event.key === 'Enter'){
                this.addCourier();
            }
        }
    },
    computed: {
        ...mCouriers([
            'activeCourierOrder',
            'countAllCouriers',
            'search_order',
        ]),
        is_searching () {
            return this.search_order.loading;
        },
        go_rest_choice() {
            return this.search_order.need_select_pos;
        },
        isShowMenu(){
            return this.isMobileScreen;
        }
    }
}
</script>
